require('./src/dragdrop.module');
require('./src/components/ac.dragdrop.service');
require('./src/directives/ac.draggable.directive');
require('./src/directives/ac.droppable.directive');
require('./src/css/styles.dragdrop.scss');